import Dayjs from 'dayjs'
import { isEmpty } from 'lodash'

import {
  transformInstallmentOrders,
  transformPlayCareTransactions
} from 'app/pages/Orders/transformers'

import { sentryLogger } from 'sentry'

import { apiEndpoints } from './common'

import { makeRequestUrl } from '../app/helpers'
import { get, post } from '../request'

const fetchOrders = async ({ url, queries } = {}) => {
  const requestUrl = !isEmpty(url)
    ? url
    : makeRequestUrl(`${apiEndpoints.orders}`, queries)

  try {
    const response = await get(requestUrl)

    return response.data
  } catch (error) {
    console.log('error in getting due payment :- ', error.message)
    throw error
  }
}

const fetchPlayCareTransactions = async ({ url, queries } = {}) => {
  const requestUrl = !isEmpty(url)
    ? url
    : makeRequestUrl(`${apiEndpoints.transaction}`, {
        ...queries,
        event_sub_type: 'play_care,drop_in_care',
        event: 'booking'
      })

  try {
    const response = await get(requestUrl)
    return transformPlayCareTransactions(response.data)
  } catch (error) {
    console.log('error in getting due payment :- ', error.message)
    throw error
  }
}

const activeCareLinkUrl = () =>
  `${apiEndpoints.invoiceSwitchBillingMode}/active_care_link`

// Every Active Care link raised from Booking, for Orders > Active Care.
const fetchActiveCareLinks = async ({ url, queries } = {}) => {
  const requestUrl = !isEmpty(url)
    ? url
    : makeRequestUrl(activeCareLinkUrl(), queries)
  const response = await get(requestUrl)
  return response.data
}

// Paid links the child was enrolled from, for Enrolments > Active Care.
const fetchActiveCareEnrolments = async ({ url, queries } = {}) =>
  fetchActiveCareLinks({ url, queries: { ...queries, enrolled: 'true' } })

const fetchInstallmentOrders = async ({ url, queries } = {}) => {
  const requestUrl = !isEmpty(url)
    ? url
    : makeRequestUrl(`${apiEndpoints.orders}/installments`, {
        ...queries
      })

  try {
    const response = await get(requestUrl)
    return transformInstallmentOrders(response?.data)
  } catch (error) {
    console.log('error in getting installment orders :- ', error.message)
    throw error
  }
}

// Feature 3 — toggle the daycare-billing flag on a preschool admission
// by reissuing the currently-pending instalment invoice under the new
// tax mode. Backend cancels the old invoice (Razorpay link cancelled)
// and creates a fresh PENDING invoice; the post_save signal generates
// the new payment link. Returns `{ new_invoice_uuid, payment_link,
// is_daycare_billing }` on success.
const switchInvoiceBillingMode = async (invoiceUuid) => {
  const url = `${apiEndpoints.invoiceSwitchBillingMode}/${invoiceUuid}/switch_billing_mode/`
  try {
    const response = await post(url, {})
    return response.data
  } catch (error) {
    sentryLogger(error, 'switchInvoiceBillingMode')
    throw error
  }
}

// Flexible Active Care / Drop-in Care links from the Booking screen.
const createActiveCareLink = async (payload) => {
  try {
    const response = await post(activeCareLinkUrl(), payload)
    return response.data
  } catch (error) {
    sentryLogger(error, 'createActiveCareLink')
    throw error
  }
}

export {
  fetchOrders,
  fetchPlayCareTransactions,
  fetchInstallmentOrders,
  fetchActiveCareLinks,
  fetchActiveCareEnrolments,
  switchInvoiceBillingMode,
  createActiveCareLink
}
